import { PageTitle } from "@components/common/page-title";
import { FaroButtonSSO } from "@components/faro-sso-button";
import { UlmContainer } from "@components/ulm/ulm-container";
import { PROVIDER_INFO } from "@constants/provider-constants";
import { Grid } from "@mui-wrapper";
import { runtimeConfig } from "@src/runtime-config";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /** Callback to set the selected provider */
  setProvider: (provider: FaroCoreApiTypes.OAuthProvider) => void;
}

/** Displays the available provider options */
export function ProviderLoginSelector({ setProvider }: Props): JSX.Element {
  return (
    <UlmContainer>
      <PageTitle>Log in with provider</PageTitle>
      {/* TODO: https://faro01.atlassian.net/browse/ST-3547 It is disabled for now because some workflows don't work */}
      {/* <Box
        sx={{
          marginTop: "10px",
          fontSize: "14px",
          color: "text.secondary",
          display: "flex",
          alignItems: "center",
        }}
      >
        Don't remember your provider?
        <Link
          component="button"
          underline="none"
          onClick={navigateToLogin}
          sx={{
            marginLeft: "5px",
            color: "primary.main",
          }}
        >
          Log in with email
        </Link>
      </Box> */}
      <Grid
        container
        spacing={2}
        sx={{
          marginTop: "20px",
        }}
      >
        {runtimeConfig.oauth.providers.map((provider) => {
          return (
            <Grid size={6} key={provider}>
              <FaroButtonSSO
                label={PROVIDER_INFO[provider]?.providerName}
                icon={PROVIDER_INFO[provider]?.icon}
                onClick={() => setProvider(provider)}
              />
            </Grid>
          );
        })}
      </Grid>
    </UlmContainer>
  );
}
